

if ('IntersectionObserver' in window) {

	const staticScrollerMain = document.querySelector('.static-scroller-left img')

	const staticScroller = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('in-view');
			} else {
				entry.target.classList.remove('in-view');
			}
		});
	});

	if (staticScrollerMain) {
		staticScroller.observe(staticScrollerMain);
	}


	// Scroller with breakpoints
	let animElement = [...document.querySelectorAll('[data-animate]')];

	let count = 0;
	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {

				breakPointNum = entry.target.getAttribute('data-breakpoint');
				animElementTarget = animElement[breakPointNum - 1];

				if (entry.isIntersecting) {
					animElementTarget.classList.add('in-view');
					animElementTarget.classList.remove('not-in-view');
				} else {

					animElementTarget.classList.remove('in-view');
					animElementTarget.classList.add('not-in-view');
				}
			});
		},
		{
			root: null, // The element used as the viewport for checking visibility
			rootMargin: '0px', // Margin around the root. Can have values similar to the CSS
			threshold: [0.25, 0.25]  // what percentage of the target is visible
		}
	);

	const targets = document.querySelectorAll('[data-breakpoint]');


	if (targets) {
		for (const target of targets) {
			observer.observe(target);
		}
	}



} else {

}

// Standard fade-in class
if ('IntersectionObserver' in window) {
	const fadeClass = document.querySelector("fade-in")

	const callback = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("fadeIn")
			}
		})
	}
	const options = {}

	const myObserver = new IntersectionObserver(callback, options)

	if (fadeClass) {
		myObserver.observe(fadeClass)
	}
} else {

}



